// extracted by mini-css-extract-plugin
module.exports = {"pwaPopup":"InstallPwaPopup_pwaPopup__1dYAv","icon":"InstallPwaPopup_icon__1MULY","instruction":"InstallPwaPopup_instruction__3z0n2"};